module.exports = __webpack_public_path__ + "img/integracoes.892d9f65.svg";